// Конфигурация API
// src/config/api.js

// Базовый URL для API запросов
// На локалке: пустая строка (используем прокси из package.json)
// На сервере: полный URL (например, http://IP:3002)
// Примечание: В development режиме прокси автоматически перенаправляет /api/* на localhost:3002
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Функция для создания полного URL API запроса
export const getApiUrl = (path = '') => {
    // Если path не передан или undefined, возвращаем базовый путь
    if (!path) {
        return API_BASE_URL || '';
    }
    
    // Убираем начальный слеш из path, если он есть
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Если установлен REACT_APP_API_URL, используем его
    if (API_BASE_URL) {
        // Убираем завершающий слеш из API_BASE_URL, если есть
        const baseUrl = API_BASE_URL.replace(/\/$/, '');
        return `${baseUrl}/${cleanPath}`;
    }
    
    // Иначе используем относительный путь - прокси или сервер обработает
    // В development: прокси из package.json перенаправит на localhost:3002
    // В production: Express сервер обработает напрямую
    return `/${cleanPath}`;
};

export default {
    API_BASE_URL,
    getApiUrl
};

